import { css } from "styled-components";

export default css`

  // -------------- antd Input styles ------------------- //

  .ant-input,
  .ant-input-number {
    height: 40px;
    width: 100%;
    min-width: 40px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.1em;
    border: 1px solid ${({ theme }) => theme.tertiary10};
    background-color: transparent;

    &:hover,
    &:focus {
      border-color: ${({ theme }) => theme.tertiary10};
      box-shadow: none;
    }
  }

  .ant-input-affix-wrapper {
    border-radius: 10px;
    padding: 0 11px;
  }

  .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover,
  .ant-input-affix-wrapper-focused {
    border-color: ${({ theme }) => theme.tertiary10};
    box-shadow: none;
  }

  .ant-input-number-focused {
    border-color: ${({ theme }) => theme.tertiary10};
    box-shadow: none !important;
  }

  .ant-input-number-handler-wrap {
    display: none;
  }

  .ant-input-number-input-wrap {
    width: 100%;
  }

  .ant-input-group-wrapper {
    margin-top: 0.1em;

    .ant-input {
      margin-top: 0;
    }
  }

  .ant-input:placeholder-shown {
    text-transform: initial;
  }

  .ant-input-disabled {
    color: ${({ theme }) => theme.tertiary10} !important;
    background-color: transparent !important;
  }
  .ant-input-disabled + .ant-input-group-addon {
    cursor: not-allowed;

    .app-input-addon-button {
      color: ${({ theme }) => theme.tertiary10};
    }
  }
  .ant-input-number-disabled {
    color: ${({ theme }) => theme.tertiary10};
    background-color: #f4f4f4;

    &:hover {
      border-color: #d9d9d9;
    }
  }

  // -------------- Antd Dropdown styles ------------------- //

  .ant-dropdown-menu-item {
    padding-left: 0;
    border-left: 6px solid transparent;

    span {
      padding-left: 10px;
    }
  }

  .ant-dropdown-menu-item-active {
    border-left: 6px solid ${({ theme }) => theme.primary11};
    color: ${({ theme }) => theme.primary11};
    // font-weight: bold;
  }

  .ant-dropdown-menu-item:hover {
    background-color: ${({ theme }) => theme.secondary12};
  }

  // -------------- Antd datepicker styles ------------------- //

  .ant-picker {
    background-color: transparent;
    border: 1px solid;
    width: 100%;
    min-height: 40px;
    border-radius: 10px;
  }
  // -------------- Antd Select styles ------------------- //
  .ant-select-selector {
    height: auto !important;
    min-height: 40px !important;
    background-color: #fcfdfe !important;
    border-radius: 10px !important;
    border: 1px solid #e2e2ea !important;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid ${({ theme }) => theme.tertiary10} !important;
    background-color: transparent !important;

    &:hover,
    &:focus {
      border: 1px solid ${({ theme }) => theme.tertiary10} !important;
    }

    .ant-select-selection-item {
      font-size: 1.8ch;
    }

    .ant-select-selection-search-input {
      height: 100% !important;
    }
  }

  .ant-select-focused.ant-select-single:not(.ant-select-customize-input)
    .ant-select-selector {
    border-color: ${({ theme }) => theme.tertiary10} !important;
    box-shadow: none !important;
  }

  // -------------- Antd Upload styles ------------------- //

  .ant-upload-disabled {
    cursor: disabled;
  }

  // -------------- Antd Modal styles ------------------- //

  .ant-modal {
    width: fit-content !important;

    .ant-modal-content {
      border-radius: 12px;
    }

    .ant-modal-body {
      padding: 0;
    }
  }

  .ant-modal-wrap {
    &::-webkit-scrollbar {
      display: none;
    }
  }
  body.ant-scrolling-effect {
    width: 100% !important;
  }
  .ant-form-item-label
    > label.ant-form-item-required:not(.ant-form-item-required-mark-optional) {
    padding-right: 8px;
  }
  .ant-form-item-label
    > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
    position: absolute;
    right: 3px;
    font-size: 10px;
    top: 5px;
    margin-right: -3px;
  }
  .ant-form-item-label > label.ant-form-item-no-colon::after {
    display: none;
  }
  .ant-picker:hover,
  .ant-picker-focused {
    border-color: #000;
    box-shadow: none;
  }

  .ant-row .ant-col {
    min-height: auto;
  }

  //carousel
  .ant-carousel .slick-dots {
    margin: 0;
    & li button:before {
      display: none;
    }
  }
  .ant-carousel .slick-dots {
    top: 30px;
    left: auto;
    width: auto;
    right: 30px;
    height: 10px;
    margin: 0;
  }
  .ant-carousel .slick-dots li {
    width: 15px;
    & > button {
      background: #000;
    }
  }
  .ant-carousel .slick-dots li button {
    border-radius: 50%;
    height: 10px;
    width: 10px;
  }
  .ant-carousel .slick-dots li.slick-active {
    width: 15px;
    & > button {
      background: white;
    }
  }
  .ant-select.ant-select-in-form-item {
    max-width: 100%;
    min-width: 100%;
  }
  @media only screen and (min-width: 992px) {
    .ant-select.ant-select-in-form-item {
      max-width: 300px;
      min-width: 200px;
    }
  }
`;
